import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../servicios/auth.service';
import {Usuario} from '../../layout/content/seguridad/usuario/recursos/modelo/usuario';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import swal from 'sweetalert2';
import {PasswordValidation} from './password-validation';
import {SecurityConfigService} from '../servicios/security-config.service';
import {UtilConfig} from '../servicios/UtilConfig';
import {ConsumerService} from '../../layout/recursos/servicio/consumer.service';
import {WebServices} from '../../layout/recursos/modelo/consumerModel/web-services.enum';
import {Emisor} from '../../layout/content/seguridad/emisor/recursos/modelo/emisor';

@Component({
    selector: 'reset-clave',
    templateUrl: './views/reset-clave.component.html',
    styleUrls: ['./css/reset-clave.component.scss'],
    providers: [AuthService, SecurityConfigService, ConsumerService]
})
export class ResetClaveComponent implements OnInit {
    token: string;
    sub: any;
    datosUsuario: Usuario;
    configuration: any;
    cargandoList = false;
    mensaje = false;
    regExp = '';
    numClav = 0;

    form: FormGroup;
    vdl_ruc: FormControl;
    vld_username: FormControl;
    vdl_pass: FormControl;
    vld_confirmPass: FormControl;
    vld_passActual: FormControl;


    constructor(private router: Router, private route: ActivatedRoute, private auth: AuthService,
                private fb: FormBuilder, private securityConfig: SecurityConfigService, private jwtUtil: UtilConfig,
                private consumerService: ConsumerService) {
        this.createFormControls();
        this.createForm();
    }

    ngOnInit(): void {
        this.sub = this.route.queryParams.subscribe(params => {
            this.token = params['token'];
            if (this.token) {
                this.auth.findByToken(this.token).subscribe(res => {
                    debugger;
                    const respuesta = JSON.parse(res._body);
                    this.datosUsuario = respuesta.usuario;
                    this.datosUsuario.customer = new Emisor();
                    this.datosUsuario.customer.id = respuesta.customerId;
                    this.datosUsuario.customer.ruc = respuesta.ruc;
                    this.securityConfig.obtenerConfiguracion(this.vld_username.value, this.vdl_ruc.value, this.datosUsuario.customer.id).subscribe(config => {
                        const configuration = JSON.parse(config._body);
                        this.regExp = configuration.configurationSecurity.passwordRegex;
                        this.numClav = configuration.configurationSecurity.numberPasswordRemember;
                        this.createFormControls(this.regExp);
                        this.createForm();
                        this.vdl_ruc.setValue(this.datosUsuario.customer.ruc);
                        this.vld_username.setValue(this.datosUsuario.username);
                    });
                });
            } else {
                this.datosUsuario = this.jwtUtil.getCurrentUser();
                this.securityConfig.obtenerConfiguracion(this.datosUsuario.username, this.datosUsuario.customer.ruc, this.datosUsuario.customer.id).subscribe(config => {
                    const configuration = JSON.parse(config._body);
                    this.regExp = configuration.configurationSecurity.passwordRegex;
                    this.numClav = configuration.configurationSecurity.numberPasswordRemember;
                    this.createFormControls(this.regExp);
                    this.createForm();
                    this.vdl_ruc.setValue(this.datosUsuario.customer.ruc);
                    this.vld_username.setValue(this.datosUsuario.username);
                });
            }


        });
    }

    createFormControls(pattern?: string) {
        this.vdl_ruc = new FormControl({value: ''}, Validators.required);
        this.vld_username = new FormControl({value: ''}, Validators.required);
        this.vdl_pass = new FormControl({value: ''}, [Validators.required, Validators.pattern(pattern)]);
        this.vld_confirmPass = new FormControl({value: ''}, [Validators.required, Validators.pattern(pattern)]);
        if (this.token)
            this.vld_passActual = new FormControl({value: ''});
        else {
            this.vld_passActual = new FormControl({value: ''}, Validators.required);
        }
    }


    createForm() {
        this.form = this.fb.group({
            'ruc': this.vdl_ruc,
            'username': this.vld_username,
            'newPass': this.vdl_pass,
            'confirmPass': this.vld_confirmPass,
            'passActual': this.vld_passActual
        }, {
            validator: [PasswordValidation.MatchPassword]
        });
        this.vld_passActual.setValue('');
        this.vdl_pass.setValue('');
        this.vld_confirmPass.setValue('');
    }

    deshabilitarBoton(): boolean {
        return !this.form.valid;
    }

    recuperarClave() {
        // LLAMADO AL SERVICIO
        this.cargandoList = true;
        if (this.token) {
            this.auth.resetClave(this.vld_username.value, this.vdl_ruc.value, this.vdl_pass.value)
                .subscribe(result => {
                    const res = JSON.parse(result._body);
                    if (res.codigo == 1)
                        this.mensaje = true;
                    else
                        swal({
                            title: 'Error',
                            text: result.mensaje,
                            type: 'error',
                            showCancelButton: false,
                            confirmButtonText: 'Proceder!'
                        });
                    this.cargandoList = false;
                }, err => {
                    this.cargandoList = false;
                    swal({
                        title: 'Error',
                        text: 'El ruc y correo ingresado son incorrectos.',
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'Proceder!'
                    });
                });
        } else {
            const body = JSON.stringify({
                usuario: {
                    username: this.datosUsuario.username,
                    password: this.vld_passActual.value,
                    passwordNueva: this.vdl_pass.value,
                    passwordConfirmacion: this.vld_confirmPass.value
                }
            });
            this.consumerService.update(WebServices.URL_CAMBIAR_CLAVE, body).subscribe(result => {
                if (result.codigo == 1) {
                    swal({
                        title: 'Clave actualizada',
                        text: 'Fue actualizada exitosamente la contraseña.',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 3000
                    });
                    this.router.navigate(['/content', {outlets: {'second': ['home']}}]);
                } else {
                    swal({
                        title: 'Error',
                        text: result.mensaje,
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'Proceder!'
                    });
                }
                this.cargandoList = false;
            }, err => {
                this.cargandoList = false;
                swal({
                    title: 'Error',
                    text: err.mensaje,
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Proceder!'
                });
            });
        }
    }

    irLogin() {
        if (this.jwtUtil.getJwtToken() == null) {
            this.router.navigate(['/']);
        } else {
            this.router.navigate(['/content', {outlets: {'second': ['home']}}]);
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/resetClave/reset-clave.component.ts